// Keys that must never be written to localStorage. They live only in a module-
// scope Map so that an XSS injection cannot read them from `window.localStorage`.
// On page refresh these values are lost; Firebase's own IndexedDB persistence
// re-establishes auth and rehydrates the token via onAuthStateChanged.
const IN_MEMORY_KEYS = new Set(['token']);

class Storage {
  constructor() {
    this.memory = new Map();
    try {
      localStorage.setItem('checkStorage', 'true');
      localStorage.getItem('checkStorage');
      localStorage.removeItem('checkStorage');
      this.backing = localStorage;
    } catch (e) {
      this.backing = null;
    }
  }

  isMemoryOnly(name) {
    return IN_MEMORY_KEYS.has(name) || !this.backing;
  }

  setItem = (name, value) => {
    if (this.isMemoryOnly(name)) {
      this.memory.set(name, value);
      return;
    }
    this.backing.setItem(name, value);
  };

  getItem = (name) => {
    if (this.isMemoryOnly(name)) {
      const v = this.memory.get(name);
      return v === undefined ? null : v;
    }
    return this.backing.getItem(name);
  };

  removeItem = (name) => {
    if (this.isMemoryOnly(name)) {
      this.memory.delete(name);
      return;
    }
    this.backing.removeItem(name);
  };

  clear = () => {
    this.memory.clear();
    if (this.backing) this.backing.clear();
  };

  // Kept for API compatibility with the old in-memory fallback; not load-bearing.
  length = () => this.memory.size + (this.backing ? this.backing.length : 0);
  key = (name) =>
    [...this.memory.keys(), ...(this.backing ? Object.keys(this.backing) : [])].indexOf(name);
}

const storageInstance = new Storage();

export default storageInstance;
